import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TopBar } from "./TopBar";
import logo from "@/assets/logo.asset.json";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
] as const;

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <TopBar />
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20 md:h-24 gap-4">
          {/* Desktop nav left */}
          <nav className="hidden md:flex items-center gap-7 flex-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="font-display font-semibold uppercase tracking-wide text-sm text-ink hover:text-brand transition-colors"
                activeProps={{ className: "text-brand" }}
                activeOptions={{ exact: item.to === "/" }}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Logo center */}
          <Link to="/" className="flex-shrink-0 flex justify-center md:flex-1">
            <img
              src={logo.url}
              alt="Homestead Construction of NEA"
              className="h-14 md:h-20 w-auto"
            />
          </Link>

          {/* CTA right */}
          <div className="hidden md:flex items-center justify-end flex-1">
            <Button asChild variant="brand" size="lg">
              <a href="tel:5015936361"><Phone className="h-4 w-4" /> Call Us</a>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 text-ink"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile nav */}
        {open && (
          <nav className="md:hidden border-t py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="font-display font-semibold uppercase tracking-wide text-sm text-ink"
                activeProps={{ className: "text-brand" }}
                activeOptions={{ exact: item.to === "/" }}
              >
                {item.label}
              </Link>
            ))}
            <Button asChild variant="brand" size="lg" className="mt-2 w-full">
              <a href="tel:5015936361" onClick={() => setOpen(false)}>
                <Phone className="h-4 w-4" /> Call Us
              </a>
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
}
